import { Box, Button } from '@mui/material';
import { styled } from '@mui/system';

export const StyledHorizontalCardContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing('24px', '24px', '24px', '24px'),
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: 'transparent',
  marginBottom: theme.spacing(4),
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: '8px',
  alignItems: 'center',
  minWidth: '100%',
  justifyContent: 'space-between',
  borderColor: theme.palette.other.outlineBorder,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '100%',
  },
}));

export const StyledInnerRightCardContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 0, 0, 5),
  justifyContent: 'center',
  gap: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 0, 0, 0),
    maxWidth: '100%',
    minWidth: '100%',
  },
}));

export const StyledTitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'center',
  [theme.breakpoints.down(920)]: {
    padding: theme.spacing(0, 0, 0, 0),
    flexDirection: 'row',
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
  },
}));

export const StyledContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.text.secondary,
  fontSize: '16px',
  minWidth: '100%',
  [theme.breakpoints.down(920)]: {
    minWidth: 'auto',
  },
}));

export const StyledBottomContainer = styled(Box)(({ theme }) => ({
  marginTop: '24px',
  minWidth: '100%',
  [theme.breakpoints.down(920)]: {
    flexDirection: 'column',
  },
}));

export const StyledSideContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 0, 0, 4),
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down(920)]: {
    padding: theme.spacing(0, 0, 0, 0),
    flexDirection: 'column',
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
  },
}));

export const StyledCTAButton = styled(Button)(({ theme }) => ({
  marginLeft: 'auto',
  marginTop: theme.spacing(0),
  minWidth: '135px',
  [theme.breakpoints.down(920)]: {
    minWidth: '100%',
    marginTop: theme.spacing(3),
  },
}));

export const StyledSideCTAButton = styled(Button)(({ theme }) => ({
  marginLeft: 'auto',
  marginTop: theme.spacing(0),
  minWidth: '120px',
  [theme.breakpoints.down(920)]: {
    marginTop: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
  },
}));

export const StyledServicesContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 0',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
}));

export const StyledSubTitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
  },
}));

export const StyledServicesDescriptionContainer = styled(Box)(() => ({
  alignSelf: 'stretch',
  fontSize: '16px',
}));

export const StyledLabelContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginRight: 'auto',
  color: theme.palette.text.primary,
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontSize: '14px',
  fontWeight: 700,
  flexDirection: 'row',
  [theme.breakpoints.down(920)]: {
    padding: theme.spacing(0, 0, 0, 0),
    flexDirection: 'column',
  },
}));

export const StyledCaptionContainer = styled(Box)(() => ({
  display: 'flex',
  marginLeft: 'auto',
  color: 'inherit',
  flexDirection: 'row',
  '@media (max-width: 920px)': {
    padding: '0',
    flexDirection: 'column',
  },
}));

export const StyledTopCardContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
